module.exports = __webpack_public_path__ + "static/media/title_pickup.b41543db.webp";